import axios from "axios";
import {setMaintainTime} from "app/store/slices/setting";
import {getStore} from "app/store/storeAccessor";
import {config} from "app/config";

axios.defaults.baseURL = config.base_url;
axios.defaults.headers.common["X-Token"] = "";
axios.defaults.headers.common["X-Lang"] = "2";
axios.defaults.headers.common["X-Platform-Id"] = config.platform_id;
axios.defaults.headers.common["X-Login-Method"] = "0";

export const setLoginMethod = (method: string) => {
    axios.defaults.headers.common["X-Login-Method"] = method;
};

export const setSeonSession = (seonSession: string | undefined) => {
    if (seonSession) {
        axios.defaults.headers.common["X-Seon-Session"] = seonSession;
    } else {
        delete axios.defaults.headers.common["X-Seon-Session"];
    }
};

const client = {
    get: axios.get,
    post: axios.post,
    put: axios.put,
    delete: axios.delete,

    setToken: (token: string) => {
        axios.defaults.headers.common["X-Token"] = token;
    },
    setSeonSession,
};

axios.interceptors.request.use(
    (config) => {
        const isBrowser = typeof window !== "undefined" && typeof window.localStorage !== "undefined";
        try {
            if (isBrowser) {
                const stored = localStorage.getItem("playing-user");
                if (stored) {
                    const {token} = JSON.parse(stored);

                    if (token) {
                        config.headers["X-Token"] = token.replace(/^"|"$/g, "");
                    }
                }
            }
        } catch (er) {
            console.log(er);
        }
        return config;
    },
    (error) => Promise.reject(error),
);

axios.interceptors.response.use(
    (response) => {
        if (response.status === 200) {
            if (response.data.code === 98) {
                // getStore().dispatch(loginOut());
            } else if (response.data.code === 100) {
                getStore().dispatch(setMaintainTime(response.data.data));
            }
        }
        return response;
    },
    (error) => {
        return Promise.reject(error);
    },
);

export default client;
